import { create } from "zustand";

interface BreadcrumbStore {
  currentExperimentTitle: string | null;
  setCurrentExperimentTitle: (title: string | null) => void;
  currentLearningTitle: string | null;
  setCurrentLearningTitle: (title: string | null) => void;
  currentInsightTitle: string | null;
  setCurrentInsightTitle: (title: string | null) => void;
  currentHypothesisLabel: string | null;
  setCurrentHypothesisLabel: (label: string | null) => void;
}

export const useBreadcrumbStore = create<BreadcrumbStore>((set) => ({
  currentExperimentTitle: null,
  setCurrentExperimentTitle: (title) => set({ currentExperimentTitle: title }),
  currentLearningTitle: null,
  setCurrentLearningTitle: (title) => set({ currentLearningTitle: title }),
  currentInsightTitle: null,
  setCurrentInsightTitle: (title) => set({ currentInsightTitle: title }),
  currentHypothesisLabel: null,
  setCurrentHypothesisLabel: (label) => set({ currentHypothesisLabel: label }),
}));
